module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sub-list list-reset"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "2"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "sub"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0734a9f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideRightList.vue
// module id = 901
// module chunks = 1